export { default } from "./TableFooter.js";
export { default as tableFooterClasses } from "./tableFooterClasses.js";
export * from "./tableFooterClasses.js";